export class PartnerDTO {
    id!: number;
    name?: string;
    partnerPartnerType:[]=[];
    AddPartnerPartnerType?:any;
    DeletedPartnerPartnerType?:any;
    isActive?: boolean;
  }